import { ErrorContentIsland, Stack } from '@razz-team/ui-web';
import { useDigitalWalletTokenQuery } from '../../../api/digital-wallet-tokens';
import { Route } from '../../../routes/account.dwt_.$tokenId';
import { DigitalWalletTokenStatus } from './DigitalWalletTokenStatus';
import { DigitalWalletTokenDetails } from './DigitalWalletTokenDetails';
import { DigitalWalletTokenActions } from './DigitalWalletTokenActions';
import { MainLayout } from '../../Layout/MainLayout';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { useTranslation } from 'react-i18next';
import { useWalletName } from '../../DigitalWalletToken/useWalletName';
import { useCardQuery } from '../../../api/cards';

export function DigitalWalletTokenPage() {
  const { tokenId } = Route.useParams();
  const { t } = useTranslation();
  const tokenQuery = useDigitalWalletTokenQuery({ tokenId });
  const cardQuery = useCardQuery({ cardId: tokenQuery.data?.cardId });

  const wallet = useWalletName(tokenQuery.data);

  const error = tokenQuery.error ?? cardQuery.error;

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={t('Add {{card}} to {{wallet}}', { card: cardQuery.data?.name, wallet })}
          loading={tokenQuery.isPending}
          parent={{
            to: '/account/home',
            title: t('Home'),
          }}
        />
      }
      compact
    >
      {tokenQuery.isPending || cardQuery.isPending ? null : error ? (
        <ErrorContentIsland error={error} />
      ) : tokenQuery.isSuccess && cardQuery.isSuccess ? (
        <Stack spacing={4} width="100%" alignItems="center">
          <DigitalWalletTokenStatus token={tokenQuery.data} card={cardQuery.data} />
          <DigitalWalletTokenDetails token={tokenQuery.data} />
          <DigitalWalletTokenActions token={tokenQuery.data} />
        </Stack>
      ) : null}
    </MainLayout>
  );
}
